import type { TFunction } from 'i18next';

/**
 * Converts an unrecognized status code into a readable label (e.g.
 * "SHIPMENT_CREATED" -> "Shipment created") as a fallback for codes with no
 * translation entry yet — keeps future/unknown statuses readable instead of
 * shown as a raw enum value.
 */
function humanize(status: string): string {
  return status
    .trim()
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * Human-readable label for an agent-provided order/shipment status code.
 * Looks up `ChatbotUI.OrderBlocks.StatusLabel_<CODE>` (uppercased, so this is
 * case-insensitive same as {@link getStatusChipColor}); falls back to a
 * humanized version of the raw code when there's no translation entry yet.
 */
export function getStatusLabel(status: string | undefined, t: TFunction): string {
  if (!status) return '';
  const code = status.trim().toUpperCase();
  const key = `ChatbotUI.OrderBlocks.StatusLabel_${code}`;
  return t(key, { defaultValue: humanize(status) });
}
